<template>
  <div class="wrap">
    <div class="back-btn"><el-button size="medium"  @click="handleBack">返回</el-button></div>
    <!--送水活动-->
    <template v-if="activityType === '8'">
      <div class="content">
        <div class="title appli">申请信息</div>
        <div class="label">
          <div class="tab"><span>申报单号：</span><span>{{formWater.id}}</span></div>
          <div class="tab"><span>活动类型：</span><span>{{formWater.activityType}}</span></div>
          <div :class="['tab', formWater.approvalStatusCode === 4 ? 'reason' : '']"><span>审核状态：</span><span>{{formWater.approvalStatus}}</span></div>
          <div :class="['tab', formWater.configurationStatusCode === 2 ? 'reason' : '']"><span>配置状态：</span><span>{{formWater.configurationStatus}}</span></div>
          <div class="tab"><span>创建人：</span><span>{{formWater.createUser}}</span></div>
          <div class="tab"><span>创建时间：</span><span>{{formWater.createTime}}</span></div>
          <div class="tab"><span>手机号：</span><span>{{formWater.payeePhone}}</span></div>
          <div class="tab"><span>姓名：</span><span>{{formWater.payeeName}}</span></div>
          <div class="tab"><span>身份证号：</span><span>{{formWater.payeeCard}}</span></div>
          <div class="tab"><span>关联微信号：</span><span>{{formWater.nickname}}</span></div>
          <div class="tab"><span>活动开始时间：</span><span>{{formWater.beginTime}}</span></div>
          <div class="tab"><span>活动结束时间：</span><span>{{formWater.endTime}}</span></div>
        </div>
      </div>
    </template>
    <!--精准营销-->
    <template v-else-if="activityType === '10'">
      <div class="content">
        <div class="title appli">申请信息</div>
        <div class="label">
          <!-- <div class="tab"><span>任务名称：</span><span>{{form.taskName}}</span></div> -->
          <div class="tab"><span>申报单号：</span><span>{{form.id}}</span></div>
          <div class="tab"><span>审核类型：</span><span>{{activityTypeMenu[form.activityType]}}</span></div>
          <div :class="['tab', form.approvalStatusCode === 4 ? 'reason' : '']"><span>申请状态：</span><span>{{form.approvalStatus}}</span></div>
          <div class="tab"><span>创建人：</span><span>{{form.createUser}}</span></div>
          <div class="tab"><span>创建时间：</span><span>{{form.createTime}}</span></div>
        </div>
        <div class="title">任务信息</div>
        <div class="rule">
          <div class='form_item'>
            <div class='form_item_lable'>任务名称：</div>
            <div class='form_item_con'>{{form.taskName}}</div>
          </div>
          <!-- <div class='form_item'>
            <div class='form_item_lable'>油站名称：</div>
            <div class='form_item_con'>{{form.gasName}}</div>
          </div> -->
          <div class='form_item'>
            <div class='form_item_lable'>发券目的：</div>
            <div class='form_item_con'>{{form.targetName}}</div>
          </div>
          <div class='form_item'>
            <div class='form_item_lable'>发券画像：</div>
            <div class='form_item_con'>{{form.portrayalName}}（{{form.setUserNum}}人）</div>
          </div>
          <div class='form_item'>
            <div class='form_item_lable'>发放券包：</div>
            <div class='form_item_con'>
              <div class='coupon_flex'>
                <CouponItem :isShow="true" :oilName="userInfo.gasName" v-for="(item, index) in form.couponList" :item='item' :key='index' />
              </div>
              <div class='form_tip'>每位车主可收到<span class='sign'>{{allCoupon}}</span>张共计<span class='sign'>{{allMoney}}</span>元的优惠券</div>
            </div>
          </div>
          <div class='form_item'>
            <div class='form_item_lable'>成本预估：</div>
            <div class='form_item_con form_tip'>预计触达用户数<span class='sign'>{{form.setUserNum}}</span>人 预估发券成本<span class='sign'>{{allBudget}}</span>元<span class="word_fa">（您发的券被用户核销使用时，才会产生实际营销成本）</span></div>
          </div>
          <div class='form_item'>
            <div class='form_item_lable'>发券时间：</div>
            <div class='form_item_con'>定时发放 {{form.setStartTime}}</div>
          </div>
          <div class='form_item'>
            <div class='form_item_lable'>发券人数：</div>
            <div class='form_item_con'>计划发放{{form.setUserNum}}人</div>
          </div>
          <!-- 0 短信 1 push -->
          <div class='form_item'>
            <div class='form_item_lable'>通知方式</div>
            <div class='form_item_con'>
              <div>{{form.noticeWayName}}</div>
              <div class='send_con'>
                <div class='send_box' v-if="form.smsContent">
                  <div class='send_title'>短信推送</div>
                  <div class='send_content'>
                    <div class='content_txt'>{{form.smsContent}}</div>
                  </div>
                </div>
                <div class='send_box' v-if="form.pushContent">
                  <div class='send_title'>APP推送</div>
                  <div class='send_content'>
                    <div class='content_txt'>
                      <div class='flex_con'><img class='logo_icon' src="https://web.nlktj.com/ty/merchant/persisMarket/logo.png" alt=""><span class='logo_name'>团油</span></div>
                      <div class='h3_txt'>{{form.pushTitle}}</div>
                      <div>{{form.pushContent}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!--抽奖宝-->
    <template  v-else-if="activityType === '11'">
      <div class="content">
        <div class='activity_info' v-if="form.approvalStatusCode === 2">* 若活动开始前仍未审核通过，活动将默认审核驳回，请及时联系MD进行审核。</div>
        <div class="content-trea-back"  v-if="form.approvalStatusCode === 2"></div>
        <div class="content-trea">
          <div class="title appli">申请信息</div>
          <div class="label">
            <div class="tab"><span>申报单号：</span><span>{{form.applyId}}</span></div>
            <div class="tab"><span>申报类型：</span><span>{{activityTypeMenu[form.activityType]}}</span></div>
            <div :class="['tab', form.approvalStatusCode === 4 ? 'reason' : '']"><span>申请状态：</span><span>{{form.approvalStatus}}</span></div>
            <div class="tab reason" v-if="form.approvalStatusCode === 4"><span>驳回原因：</span><span>{{form.withdrawReason}}</span></div>
            <div class="tab"><span>审核人：</span><span>{{form.applyUser}}</span></div>
            <div class="tab"><span>创建人：</span><span>{{form.createUser}}</span></div>
            <div class="tab"><span>创建时间：</span><span>{{form.createTime}}</span></div>
          </div>
          <div class="title">活动内容</div>
          <div class="rule" v-if="form.regulationVosJson">
            <div class='form_item'>
              <div class='form_item_lable'>活动油站：</div>
              <div class='form_item_con'>{{form.regulationVosJson.gasName}}</div>
            </div>
            <div class='form_item'>
              <div class='form_item_lable'>活动时间：</div>
              <div class='form_item_con'>{{form.regulationVosJson.beginTime}} - {{form.regulationVosJson.endTime}}</div>
            </div>
            <div class='form_item'>
              <div class='form_item_lable'>收货人：</div>
              <div class='form_item_con'>{{form.regulationVosJson.receiver}}</div>
            </div>
            <div class='form_item'>
              <div class='form_item_lable'>联系电话：</div>
              <div class='form_item_con'>{{form.regulationVosJson.receiverPhone}}</div>
            </div>
            <div class='form_item'>
              <div class='form_item_lable'>收货地址：</div>
              <div class='form_item_con'>{{form.regulationVosJson.address}}</div>
            </div>
            <div class='form_item'>
              <div class='form_item_lable'>活动说明：</div>
              <div class='form_item_con'>
                <span>活动时间内，<span class='bold'>拉新用户数达标后</span> 即可领取免费大奖</span>
                <div class="c_list">
                  <span>满足以下条件即为新用户：</span>
                  <span v-for="(item, index) in form.regulationVosJson.conditions" :key="index">{{item}}</span>
                </div>
              </div>
            </div>
            <div class='form_item' style="margin-top: 10px;">
              <div class='form_item_lable'>达标奖励：</div>
              <div class='form_item_con'>
                <span>活动结束后达成以下拉新条件，<span class='bold'>达标范围内</span> 可选择任意一项奖品，给你邮寄到手</span>
                <treasureList  :rewardList='form.regulationVosJson.drawRewards' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!--天天特价，限时秒杀-->
    <template  v-else>
      <!-- <div class="back-btn"><el-button size="medium"  @click="handleBack">返回</el-button></div> -->
      <div class="content">
        <div class="title appli">申请信息</div>
        <div class="label">
          <div class="tab"><span>申报单号：</span><span>{{form.applyId}}</span></div>
          <div class="tab"><span>活动类型：</span><span>{{activityTypeMenu[form.activityType]}}</span></div>
          <div :class="['tab', form.approvalStatusCode === 4 ? 'reason' : '']"><span>申请状态：</span><span>{{form.approvalStatus}}</span></div>
          <div class="tab" v-if="form.isFundUsed !== null"><span>是否使用营销基金：</span><span>{{isFundUsedMenu[form.isFundUsed]}}</span></div>
          <div class="tab" v-if="form.isRebate !== null"><span>商家返券：</span><span>{{isRebateMenu[form.isRebate]}}</span></div>
          <div class="tab reason" v-if="form.activityStatus === 8"><span>驳回原因：</span><span>{{form.withdrawReason}}</span></div>
          <div class="tab"><span>创建人：</span><span>{{form.createUser}}</span></div>
          <div class="tab"><span>创建时间：</span><span>{{form.createTime}}</span></div>
        </div>
        <div class="title">活动信息</div>
        <div class="rule">
          <rule-card v-for="(item, index) in form.regulationVosJson" :key="index" :data="item" :index="index" :activeType="Number(activityType)">
            <div class="tip">
              <span :class="[item.runState ? 'up' : 'noup']">{{runStateMenu[item.runState]}}</span>
            </div>
          </rule-card>
        </div>
      </div>
    </template>
    <div class="btn-wrap" v-if="activityType !== '8' && !noBtn">
      <div class="btn">
        <el-button v-if="row.agreeButton" size="medium" type="primary" @click="handleModel('agree', row.activityTypeDesc)">同意</el-button>
        <el-button v-if="row.rejectButton" size="medium" @click="handleModel('refused', row.activityTypeDesc)">驳回</el-button>
        <el-button v-if="row.withdrawalButton" class="withdraw-btn" size="medium" type="primary" @click="handleModel('withdraw', row.activityTypeDesc)">撤回</el-button>
        <el-button v-if="row.rejoinButton" size="medium" type="primary" @click="handleSign">再次报名</el-button>
      </div>
    </div>
    <actionModel ref="actionModel"/>
  </div>
</template>
<script>
import mixinBtn from './mixinBtn'
import { taskDetail } from '@/api/vipMarket'
import { operateDetail, deliverWaterDetail, operateDetailForDraw } from '@/api/marketPromotion'
import actionModel from './actionModel'
import ruleCard from '../components/ruleCard'
import CouponItem from './CouponItem.vue'
import treasureList from '../components/treasureList.vue'
import { alertType } from '@/api/vipMarket'
import { mapState } from 'vuex'
export default {
  components: {
    CouponItem,
    ruleCard,
    actionModel,
    treasureList
  },
  mixins: [mixinBtn],
  data () {
    return {
      activityId: '', // 活动id
      row: '', // 按钮展示逻辑
      activityType: undefined, // 天天特价，还是限时秒杀
      form: {}, // 精准营销，天天特价，限时秒杀表单数据
      formWater: {}, // 送水详情
      coupons: [],
      rewardList: []
    }
  },
  computed: {
    noBtn () {
      const { agreeButton, rejectButton, withdrawalButton, rejoinButton } = this.row
      return !agreeButton && !rejectButton && !withdrawalButton && !rejoinButton
    },
    allCoupon () {
      const { couponList = [] } = this.form
      return couponList.reduce((sum, next) => sum + next.number, 0)
    },
    allMoney () {
      const { couponList = [] } = this.form
      return couponList.reduce((sum, next) => sum + (next.amount * next.number), 0)
    },
    allBudget () {
      const { couponList = [], setUserNum } = this.form
      return couponList.reduce((sum, next) => sum + (next.amount * next.number), 0) * setUserNum
    },
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  mounted () {
    this.$track.pageViewEvent('审核中心-审核列表-审核详情', '1628236486')
    const { activityId, row } = this.$route.params
    if (activityId) {
      localStorage.setItem('btnId', activityId)
      localStorage.setItem('btnRow', row)
      localStorage.setItem('activityType', JSON.parse(row).activityType)
      this.activityId = activityId
      this.row = JSON.parse(row)
      this.activityType =  JSON.parse(row).activityType.toString()
    } else {
      this.activityId = localStorage.getItem('btnId')
      this.row = JSON.parse(localStorage.getItem('btnRow'))
      this.activityType = localStorage.getItem('activityType').toString()
    }
    switch (this.activityType) {
      case '7':
        this.operateDetail()
        break
      case '9':
        this.operateDetail()
        break
      case '8':
        this.operateWaterDetail()
        break
      case '10':
        this.taskDetailFn()
        break
      case  '11':
        this.operateDetailForDrawApi()
        break
    }
  },
  methods: {
    // 再次报名，除了天天特价，限时秒杀。都没有再次报名
    handleSign () {
      switch (this.activityType) {
        case '7':
          this.$track.clickEvent('活动营销-活动广场-天特/秒杀活动详情-再次报名', '1632832582', { tysj_trade_type: 0 })
          this.$router.push({ path: '/promotion/daySpecialSign', id: this.activityId })
          break
        case '9':
          this.$track.clickEvent('活动营销-活动广场-天特/秒杀活动详情-再次报名', '1632832582', { tysj_trade_type: 1 })
          this.$router.push({ path: '/promotion/limitShopSign', id: this.activityId })
          break
        case '10':
          this.$track.clickEvent('活动营销-活动广场-天特/秒杀活动详情-再次报名', '1632832582', { tysj_trade_type: 5 })
          this.$router.push({ path: '/vipMarket/vipDraw' })
      }
    },
    // 获取送水详情接口
    async operateWaterDetail () {
      try {
        const { code, result } = await deliverWaterDetail({ activityId: this.activityId })
        if(code !== 200) return
        const { id, activityType, nickname, payeePhone, payeeName, payeeCard, approvalStatusCode, approvalStatus, createUser, createTime, configurationStatusCode, configurationStatus, beginTime, endTime } = result
        this.formWater = { id, activityType, nickname, payeePhone, payeeName, payeeCard, approvalStatusCode, approvalStatus, createUser, createTime, configurationStatusCode, configurationStatus, beginTime, endTime }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取天天特价。限时秒杀详情数据
    async operateDetail () {
      try {
        const { code, result } = await operateDetail({ activityId: this.activityId, activityType: this.activityType })
        if(code !== 200) return
        const { applyId, activityType, activityStatus, isFundUsed, isRebate, withdrawReason, approvalStatusCode, approvalStatus, createUser, createTime, regulationVosJson } = result
        this.form = { applyId, activityType, activityStatus, isFundUsed, isRebate, withdrawReason, approvalStatusCode, approvalStatus, createUser, createTime, regulationVosJson }
        this.form.regulationVosJson = JSON.parse(regulationVosJson)
      } catch (error) {
        console.log(error)
      }
    },
    // 获取抽奖宝详情数据
    async operateDetailForDrawApi () {
      let params = {
        activityId: this.activityId,
        activityType: this.activityType
      }
      try {
        const { code, result } = await operateDetailForDraw(params)
        if (code !== 200) return
        this.form = Object.assign({}, result)
        this.form.regulationVosJson = JSON.parse(result.regulationVosJson)
      } catch (error) {
        console.log(error)
      }
    },
    // 获取精准营销任务详情
    async taskDetailFn () {
      try {
        const { code, result } = await taskDetail({ taskId: this.activityId })
        if(code !== 200) return
        this.form = Object.assign(this.row, result)
      } catch (error) {
        console.log(error)
      }
    },
    // 返回
    handleBack () {
      this.$router.push({ path: '/promotionAudit/myPromotion' })
    },
    // 操作不同按钮，调取不同接口
    async handleModel (btnType, tip) {
      const row = { activityId: this.activityId, activityType: this.activityType}
      if (this.activityType === '10' && btnType === 'agree') {
        const { result } = await alertType(row)
        if (result.newMeg) {
          const perTip = result.message
          this.$refs.actionModel.init(btnType, row, '/promotionAudit/myPromotion', tip, perTip)
        } else {
          const perTip = null
          this.$refs.actionModel.init(btnType, row, '/promotionAudit/myPromotion', tip, perTip)
        }
      } else {
        this.$refs.actionModel.init(btnType, row, '/promotionAudit/myPromotion', tip)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.wrap{
  padding: 10px 0 30px 0;
}
.back-btn{
  width: 100%;
  position: fixed;
  z-index: 1000;
  margin: 0 0 10px 0;
  padding: 0 0 10px 0;
  background: #fff;
  .el-button{
    width: 120px;
    height: 40px;
  }
}
.content{
  padding: 0 0 100px 0;
  background: #fff;
  margin-top: 60px;
  .back_btn {
    color: #4B7EFE;
    cursor: pointer;
  }
}
.content-trea-back{
  width: 100%;
  height: 15px;
  background: rgba(248,249,253,1);
}
.content-trea{
  padding: 20px 0;
}
.back{
  padding: 0 0 0 50px;
}
.title{
  margin: 20px 0 0 0;
  padding: 20px 0 0 50px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.appli{
  margin: 0;
  padding: 25px 0 0 50px;
}
.label{
  width: 100%;
  padding: 0 0 0 50px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  .tab{
    width: 25%;
    margin-top: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    >span:nth-child(1){
      min-width: 70px;
    }
    >span:nth-child(2){
      margin-left: 10px
    }
  }
  .reason{
    >span:nth-child(2){
      color: #C71818;
    }
  }
}
.rule{
  padding: 20px 0 0 50px;
  line-height: 40px;
  .tip{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    .noup{
      color: #FBA327;
    }
    .up{
      color: #3377FF;
    }
  }
}
.btn-wrap{
  width: 100%;
  height: 80px;
  bottom: 0;
  background: #FFFFFF;
  box-shadow: 0px -2px 8px 0px #F4F7FC;
  position: fixed;
  .btn{
    width: 80%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    .withdraw-btn{
      width: 120px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #CCCCCC;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
}
.form_item{
  display: flex;
  justify-content: flex-start;
  .form_item_lable{
    color: #666;
    font-size: 14px;
    margin-right: 8px;
    min-width: 70px;
  }
  .form_item_con{
    color: #222222;
    font-size: 14px;
    .coupon_flex{
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    .coupon_item{
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .send_con{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .send_box{
        width: 305px;
        height: 156px;
        border-radius: 2px;
        border: 1px solid #EBEEF5;
        margin-right: 0;
        .send_title{
          color: #333333;
          font-size: 14px;
          text-align: left;
          box-sizing: border-box;
          padding-left: 28px;
          box-shadow: 2px 0px 4px 0px rgba(64, 64, 67, 0.06);
          margin:0;
        }
        .send_content{
          width: 100%;
          height: 110px;
          background: #FAFAFA;
          display: flex;
          justify-content: center;
          align-items: center;
          .content_txt{
            width: 95%;
            font-size: 12px;
            box-sizing: border-box;
            padding: 4px;
            line-height: 17px;
            background: #fff;
            margin: 0;
            .flex_con{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 4px;
            }
            .logo_icon{
              width: 14px;
              height: 14px;
              display: inline-block;
            }
            .logo_name{
              color: #1E1E28;
              font-size: 12px;
              margin-left: 4px;
            }
            .h3_txt{
              color: #1E1E28;
              font-weight: 600;
              font-size: 12px;
            }
          }
        }
      }
    }
    .c_list{
      width: 610px;
      padding: 10px 16px 16px 16px;
      margin: 10px 16px 0 0;
      background: #F9FAFC;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      line-height: 20px;
      >span{
        height: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      >span:nth-child(1){
        margin-bottom: 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }
    }
  }
}
.form_tip{
  color: #222222;
  font-size: 14px;
  .sign{
    color: #3377FF;
  }
}
.activity_info{
  width: 100%;
  height: 52px;
  font-size: 14px;
  line-height: 52px;
  color: #3377FF;
  background: #EBF2FF;
  padding-left: 16px;
}
.bold{
  font-weight: 600;
}
.word_fa{
  color: #999999;
  font-size: 10px;
}
</style>
